export { default as UserMinusIcon } from '~icons/lucide/user-minus';
